const useCookie = () => {
  const getCookie = (name: string) => {
    var strcookie = document.cookie; //获取cookie字符串
    var arrcookie = strcookie.split("; ");
    for (var i = 0; i < arrcookie.length; i++) {
      var arr = arrcookie[i].split("=");
      if (arr[0] === name) {
        return arr[1];
      }
    }
    return "";
  };

  const setCookie = (name: string, value: string, days: number) => {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + "; " + expires;
  };

  const delCookie = (name: string) => {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    document.cookie = name + "=" + cval + "; expires=" + exp.toUTCString();
  };

  return [getCookie, setCookie, delCookie] as const;
};

export default useCookie;
